import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BotoneraModern from '../../components/Botonera/BotoneraModern.tsx';
import useNavVisibility from '../../hooks/useNavVisibility.ts';
import Breadcrumbs from '../../components/UI/Breadcrumbs/Breadcrumbs.tsx';
import MisMaterialesComercio from '../../components/Perfil/PerfilMain/MisMaterialesComercio/MisMaterialesComercio.tsx';
import { loadUserData } from '../../store/actions';
import { buildProfileUrl, getUserDisplayName } from '../../utils/navigationHelpers.ts';
import styles from './CommerceAltaPage.module.scss';

const CommerceCatalogoPage: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();
  const userData = useSelector((s: { general?: { userData?: Record<string, unknown> } }) => s.general?.userData);
  const userId = userData?.id != null ? Number(userData.id) : 0;
  const [, setInfoReady] = useState(false);
  const desdeAltaNotice = searchParams.get('desdeAlta') === '1';

  const dismissDesdeAltaBanner = useCallback(() => {
    setSearchParams(
      (prev) => {
        const n = new URLSearchParams(prev);
        n.delete('desdeAlta');
        return n;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  const goProfile = useCallback(() => {
    dispatch(loadUserData());
    const name = getUserDisplayName(userData);
    navigate(
      buildProfileUrl(String(userId), name, 'Gestión', {
        section: 'comercio',
      })
    );
  }, [dispatch, navigate, userData, userId]);

  if (!userId) {
    return null;
  }

  return (
    <div className={styles.container}>
      {ocultarEnMobile && <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
      <div className={styles.wrapper}>
        <div className={styles.breadcrumbBar}>
          <div className={styles.breadcrumbBarStart}>
            <Breadcrumbs />
          </div>
          <button type="button" className={styles.breadcrumbProfileBack} onClick={goProfile}>
            Volver al perfil
          </button>
        </div>
        <main className={styles.main}>
          <div className={styles.commerceStack}>
            <div className={styles.commerceHero}>
              <div className={styles.commerceHeroIntro}>
                <h1 className={styles.commerceHeroTitle}>Catálogo de materiales</h1>
                <div className={styles.sheetIntro}>
                  <p className={styles.subtitle}>
                    Acá ves lo que ya quedó en tu perfil: podés editar precios y datos. Para sumar materiales —de a uno,
                    con archivo o ambos— usá "Cargar o agregar materiales": ahí elegís si cargás una planilla o PDF o si
                    completás el alta manual.
                  </p>
                </div>
              </div>
              {desdeAltaNotice ? (
                <div className={styles.commerceHeroDraft}>
                  <div className={styles.desdeAltaBanner} role="status">
                    <p className={styles.desdeAltaBannerBody}>
                      <strong>Tu comercio ya está dado de alta en Edify.</strong> Para que tus productos aparezcan en la
                      plataforma tenés que cargar tu lista de materiales: tocá "Cargar o agregar materiales" y elegí alta
                      manual o archivo (según tu cuenta). Podés hacerlo ahora o volver cuando quieras desde tu perfil.
                    </p>
                    <button type="button" className={styles.desdeAltaBannerDismiss} onClick={dismissDesdeAltaBanner}>
                      Entendido
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
            <div className={styles.commerceMain}>
              <MisMaterialesComercio userData={userData} setInfoReady={setInfoReady} surface="route" />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CommerceCatalogoPage;
